import metaLogo from '../../assets/brands/gmeta.png';

/** Google + Meta mark for Ad Creatives (fills the tools-hub icon well). */
export default function MetaLogo({ className = '' }) {
  // Hub passes heroicon-sized h-6 w-6 — strip those so the brand mark stays large.
  const extras = String(className || '')
    .split(/\s+/)
    .filter((c) => c && !/^(h|w|max-h|max-w|min-h|min-w)-/.test(c))
    .join(' ');
  return (
    <img
      src={metaLogo}
      alt=""
      className={`h-10 w-10 object-contain ${extras}`.trim()}
      draggable={false}
      aria-hidden="true"
    />
  );
}
